import { inject, Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';
import { EmailAi, EmailAiTypes, RejectionEmailTriggerContext } from '@core/email-ai-types';
import { IntelligenceAnalyticsService } from '@core/intelligence-logic';

@Injectable({
  providedIn: 'root',
})
export class EmailAiAnalyticsService extends AnalyticsBase {
  private readonly intelligenceService = inject(IntelligenceAnalyticsService);

  public readonly namespace: string = 'RejectionEmailAI';
  public readonly requireViewContext: boolean = false;

  public trackRating(isHelpful: boolean, candidateId: number, data: EmailAi, topic: EmailAiTypes) {
    this.intelligenceService.track('AI writer rated', {
      topic,
      helpful: isHelpful,
      candidateId,
      requestId: data.metadata.requestId,
    });
  }

  public trackWriteEmailClicked(generateAgain: boolean) {
    generateAgain ? this.track('GenerateAgainClicked') : this.track('WriteEmailClicked');
  }

  public trackWriteRejectionEmail(context: RejectionEmailTriggerContext) {
    this.track('WriteRejectionEmailClicked', { context });
  }

  public trackRejectionBannerDismissed(dontShowAgain: boolean) {
    this.track('RejectionBannerDismissed', { dontShowAgain });
  }

  public trackInsertGeneratedEmail() {
    this.track('InsertGeneratedEmail');
  }

  public trackReplaceGeneratedEmail() {
    this.track('ReplaceGeneratedEmail');
  }
}
